// extracted by mini-css-extract-plugin
module.exports = {"step-title":"StepYearAndLight_step-title_1gxPi","list":"StepYearAndLight_list_FDWMJ"};